import { Card, Input } from "@repo/ui";
import { useEffect, useMemo, useState } from "react";

type Sub = { id: number; email: string; created_at: string };

export default function AdminNewsletter() {
  const [list, setList] = useState<Sub[]>([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      const res = await fetch("/api/admin/newsletter");
      const data = (await res.json()) as { status: string; data: Sub[] };
      setList(data.data || []);
    })();
  }, []);

  const filtered = useMemo(
    () => list.filter((s) => s.email.toLowerCase().includes(q.toLowerCase())),
    [list, q]
  );

  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl">รายชื่อสมาชิกจดหมายข่าว</h1>
      <div className="flex items-center justify-between gap-4">
        <div className="text-sm text-foreground/70">ทั้งหมด {list.length} รายการ</div>
        <Input
          className="w-64"
          placeholder="ค้นหาอีเมล"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>
      <div className="grid gap-2">
        {filtered.map((s) => (
          <Card key={s.id} className="p-3 flex items-center justify-between bg-card/60">
            <div>{s.email}</div>
            <div className="text-xs text-foreground/60">
              {new Date(s.created_at).toLocaleString("th-TH")}
            </div>
          </Card>
        ))}
        {filtered.length === 0 && (
          <Card className="p-4 text-sm text-foreground/60">ไม่พบข้อมูล</Card>
        )}
      </div>
    </div>
  );
}
